export function hasEngagementId(options) {
  return options.engagementId !== undefined;
}